/**
 * @jsxFrag
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect } from 'react';

import { TMenuItemDragAndDropState } from '@atlassian/navigation-system/side-nav/drag-and-drop/use-menu-item-drag-and-drop';

export function useFlyoutBehaviors({
	state,
	isOpen,
	setIsOpen,
}: {
	state: TMenuItemDragAndDropState;
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
}) {
	// Close flyout if dragging
	useEffect(() => {
		if (state.type === 'dragging') {
			setIsOpen(false);
		}
	}, [state.type, isOpen, setIsOpen]);
}
